import { render } from "./ImgContainer.vue?vue&type=template&id=3f887e60&scoped=true"
import script from "./ImgContainer.vue?vue&type=script&lang=js"
export * from "./ImgContainer.vue?vue&type=script&lang=js"

import "./ImgContainer.vue?vue&type=style&index=0&id=3f887e60&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f887e60"]])

export default __exports__